import { useCallback, useContext, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { createId } from '@paralleldrive/cuid2';
import { AppThemingContext, AppThemingFetchContext, AppThemingHashContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useAppSelector } from '@/store';

type Props = {
  children: React.ReactNode;
};

export const FetchAppThemingProvider = (props: Props) => {

  const apiClient = useChatApiClient();

  const fetchTheming = useCallback(() => {
    return apiClient.app.getAppTheming();
  }, [apiClient]);

  const userId = useAppSelector(state => state.user.id);
  const appThemingHash = useMemo(() => {
    return createId();
  }, [userId]);

  return (
    <AppThemingFetchContext.Provider value={fetchTheming}>
      <AppThemingHashContext.Provider value={appThemingHash}>
        {props.children}
      </AppThemingHashContext.Provider>
    </AppThemingFetchContext.Provider>
  );
};

export const AppThemingHelmet = (props: Props) => {

  const themingCtx = useContext(AppThemingContext);

  return (
    <>
      <Helmet title={themingCtx.theme?.app?.title} />
      {props.children}
    </>
  );
};